import { render, staticRenderFns } from "./appoint-material.vue?vue&type=template&id=6b1be0b5&scoped=true&"
import script from "./appoint-material.vue?vue&type=script&lang=js&"
export * from "./appoint-material.vue?vue&type=script&lang=js&"
import style0 from "./appoint-material.vue?vue&type=style&index=0&id=6b1be0b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1be0b5",
  null
  
)

export default component.exports